const cprValidation = (cpr) => {


    var multipliers = [4, 3, 2, 7, 6, 5, 4, 3, 2, 1]


    const sumProduct = (a, b) => a.reduce(function (sum, digit, i) { return sum + digit * b[i] }, 0)
    

    const modulo11 = (cpr) => {
    
    
      // extract digits
      cpr = cpr.replace(/[^\d]/g, '') 

      return sumProduct(cpr.split(''), multipliers) % 11
    }
    

    const isValid = modulo11(cpr) == 0

    return cpr? isValid : null;

}

export default cprValidation;
